import { List as MList, ListProps } from '@mui/material'

export const List: React.FC<ListProps> = (props) => {
  return <MList {...props} />
}
